<template>
  <div>
    <div class="products">
      <div class="w3-container">
        <div class="headerGrid">
          <div>
            <header>
              <h2>Products</h2>
            </header>
          </div>
          <div>
            <router-link to="/addProduct" class="w3-button w3-green w3-small w3-right vmiddle">
              <i class="fas fa-plus" style="margin-right:8px;"></i>New Product
            </router-link>
          </div>
        </div>

        <div class="w3-row">
          <article v-for="(product, idx) in state.admin.global.products.data" :key="idx">
            <div class="outline w3-white w3-margin-bottom">
              <header class="light outline categoryHeaderGrid" style="padding:6px 6px 6px 12px;">
                <h5 class="raleway">{{ product.name }}</h5>
                <div class="w3-right-align">
                  <button class="w3-button w3-green w3-small" @click="addPlanView(product.id, product.type)">add plan</button>
                  <button class="w3-button w3-red w3-small" @click="deleteProduct(product.id)">delete product</button>
                </div>
              </header>

              <div class="planGrid w3-light-grey">
                <div class="w3-padding">Plan</div>
                <div class="w3-padding w3-center">Cost</div>
                <div class="w3-padding w3-right-align">Actions</div>
              </div>

              <article v-for="(plan, idx2) in state.admin.global.plans.data" :key="idx2" class="planGrid">
                <template v-if="plan.product == product.id" class="w3-border-bottom">
                  <div class="w3-padding truncate">
                    {{plan.nickname}}
                  </div>
                  <div class="w3-padding w3-center">
                    {{plan.amount / 100 | currency}} / {{plan.interval}}
                  </div>
                  <div class="w3-right w3-right-align">
                    <button @click.prevent="editPlan(plan.id)" class="w3-button dark" style="margin:4px 0; font-size:8pt;">
                      <i class="fas fa-pen" v-if="!state.spinner.editPlan"></i>
                      <div class="lds-dual-ring" v-if="state.spinner.editPlan"></div>
                    </button>
                    <button @click.prevent="deletePlan(plan.id)" class="w3-button w3-red" style="margin:4px 4px 4px 2px; font-size:8pt;">
                      <i class="fas fa-trash" v-if="state.spinner.deletePlan !== plan.id"></i>
                      <div class="lds-dual-ring" v-if="state.spinner.deletePlan == plan.id"></div>
                    </button>
                  </div>
                </template>
              </article>

              <div class="w3-row w3-padding-v" v-if="addPlanTo == ('plan' + product.id) && product.type == 'service'">
                <div class="w3-col s12 m4">
                  <div class="w3-container">
                    <input class="w3-input w3-border" type="text" placeholder="Plan Name" v-model="newPlan.name">
                  </div>
                </div>
                <div class="w3-col s12 m2">
                  <div class="w3-container">
                    <select class="w3-input w3-border" v-model="newPlan.type">
                      <option value="choose">Choose Type</option>
                      <option value="custom">Custom</option>
                      <option value="hosting">Hosting</option>
                      <option value="domain">Domain</option>
                      <option value="email">Email</option>
                    </select>
                  </div>
                </div>
                <div class="w3-col s12 m2">
                  <div class="w3-container">
                    <select class="w3-input w3-border" type="text" v-model="newPlan.interval">
                      <option value="day">Day</option>
                      <option value="week">Week</option>
                      <option value="month">Month</option>
                      <option value="year">Year</option>
                    </select>
                  </div>
                </div>
                <div class="w3-col s12 m2">
                  <div class="w3-container">
                    <money class="w3-input w3-border" v-model="newPlan.amount" v-bind="money" @keydown.enter="savePlan(product.id)"></money>
                  </div>
                </div>
                <div class="w3-col s12 m2 w3-right-align">
                  <div style="padding-right:8px">
                    <button class="w3-button w3-green" style="margin:4px 6px 0 0; font-size:9pt;" @click="savePlan(product.id)"><i class="fas fa-check"></i></button>
                    <button class="w3-button w3-red" style="margin:4px 0 0; font-size:9pt;" @click="addPlanTo = 'plan'"><i class="fas fa-times"></i></button>
                  </div>
                </div>
              </div>

            </div>
          </article>
        </div>
      
      </div>
    </div>
  </div>
</template>

<script>
import dataStore from '../dataStore';
import {Money} from 'v-money'
import { parse } from 'path';

export default {
  name: "Products",
  components: {Money},
  data() {
    return {
      state: dataStore.state,
      newPlan: {
        name: '',
        currency: 'USD',
        type: 'choose',
        interval: 'month', // day, week, month, year
        product: '', // product id
        amount: 0
      },
      addPlanTo: 'plan',
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        precision: 2,
        masked: false
      }
    };
  },
  created() {
    // dataStore.getAdminGlobalData()
    // this.state.spinner.deletePlan = 'plan_EINHZIcSekRgjh' // TODO: testing spinner
  },
  methods: {
    savePlan(productid) {
      this.newPlan.productid = productid
      dataStore.savePlan(this.newPlan).then(result => {
        if (result == 'success') {
          this.newPlan.name = ''
          this.newPlan.amount = 0
          this.newPlan.interval = 'month'
          this.newPlan.type = 'choose'
          this.addPlanTo = 'plan'
          dataStore.getAdminGlobalData()
        }
      })
    },
    editPlan(id) {
      console.log(id) // TODO: edit plan
    },
    deletePlan(id) {
      if (confirm('Delete plan?')) {
        dataStore.deletePlan(id)
      }
    },
    deleteProduct(id) {
      if (confirm('Delete product?')) {
        dataStore.deleteProduct(id)
      }
    },
    addPlanView(id, type) {
      if (type == 'service') {
        this.addPlanTo = 'plan' + id;
      }
    }
  }
};
</script>

<style scoped>
header h5 {font-weight:500;}
.planGrid > div {border-bottom:1px solid #eee;}
</style>



// WEBPACK FOOTER //
// src/components/Products.vue